import { render, staticRenderFns } from "./up-down.vue?vue&type=template&id=5ed61696&scoped=true&"
import script from "./up-down.vue?vue&type=script&lang=js&"
export * from "./up-down.vue?vue&type=script&lang=js&"
import style0 from "./up-down.vue?vue&type=style&index=0&id=5ed61696&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed61696",
  null
  
)

export default component.exports